import { Bullet as IBullet, Vector2 } from './types';

export abstract class BaseBullet implements IBullet {
  position: Vector2;
  velocity: Vector2;
  width: number;
  height: number;
  alive: boolean = true;
  damage: number;
  speed: number;

  constructor(x: number, y: number, width: number, height: number, damage: number, speed: number) {
    this.position = { x, y };
    this.velocity = { x: 0, y: 0 };
    this.width = width;
    this.height = height;
    this.damage = damage;
    this.speed = speed;
  }

  update(deltaTime: number): void {
    this.position.x += this.velocity.x * deltaTime;
    this.position.y += this.velocity.y * deltaTime;

    if (this.position.y < -this.height || this.position.y > 700 || 
        this.position.x < -this.width || this.position.x > 900) {
      this.alive = false;
    }
  }

  abstract render(ctx: CanvasRenderingContext2D): void;
}

export class PlayerBullet extends BaseBullet {
  public id: string;
  
  constructor(x: number, y: number) {
    super(x, y, 4, 10, 1, 500);
    this.velocity.y = -this.speed;
    this.id = `player-bullet-${Date.now()}-${Math.random()}`;
  }

  render(ctx: CanvasRenderingContext2D): void {
    ctx.save();
    ctx.shadowBlur = 10;
    ctx.shadowColor = '#ffff00';
    ctx.fillStyle = '#ffff00';
    ctx.fillRect(this.position.x, this.position.y, this.width, this.height);
    ctx.restore();
  }
}

export class EnemyBullet extends BaseBullet {
  constructor(x: number, y: number, velocityX: number = 0, velocityY: number = 200) {
    super(x, y, 3, 8, 1, Math.sqrt(velocityX * velocityX + velocityY * velocityY));
    this.velocity.x = velocityX;
    this.velocity.y = velocityY;
  }

  render(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = '#ff0000';
    ctx.fillRect(this.position.x, this.position.y, this.width, this.height);
  }
}

export class BulletHell extends BaseBullet {
  private time: number = 0;

  constructor(x: number, y: number, angle: number, speed: number = 150) {
    super(x, y, 2, 2, 1, speed);
    this.velocity.x = Math.cos(angle) * speed;
    this.velocity.y = Math.sin(angle) * speed;
  }

  update(deltaTime: number): void {
    this.time += deltaTime;
    super.update(deltaTime);
  }

  render(ctx: CanvasRenderingContext2D): void {
    ctx.fillStyle = '#ff00ff';
    ctx.beginPath();
    ctx.arc(this.position.x + 1, this.position.y + 1, 2, 0, Math.PI * 2);
    ctx.fill();
  }
}